@if (show()) {
  <a
    class="cabinet-profile-incomplete-banner"
    [routerLink]="editLink()"
    [attr.aria-label]="messageKey() | translate: messageParams()"
  >
    <span class="cabinet-profile-incomplete-banner__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
          stroke="currentColor"
          stroke-width="1.75"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
    <span class="cabinet-profile-incomplete-banner__text">{{
      messageKey() | translate: messageParams()
    }}</span>
    <span class="cabinet-profile-incomplete-banner__arrow" aria-hidden="true"
      >→</span
    >
  </a>
}
